import { Dayjs } from "dayjs"
import { IWarrantsDcaTicket } from "@/models/admin/warrantsDcaTicket/warrantsDcaTicket.types"
import { sentenceCase } from "@/helpers/stringHelpers"

export class WarrantsDcaTicket implements IWarrantsDcaTicket {
  constructor(
    public id: number,
    public accountNumber: string,
    public dcaType: string,
    public status: string,
    public type: string,
    public ticketDefinition: string | null,
    public ticketId: string | null,
    public ticketStep: string | null,
    public createdAt: Dayjs,
    public deletedAt: Dayjs | null,
  ) {}

  get isDeleted(): boolean {
    return this.deletedAt !== null
  }

  get statusDisplay(): string {
    return sentenceCase(this.status)
  }

  get dcaTypeDisplay(): string {
    return sentenceCase(this.dcaType)
  }

  get typeDisplay(): string {
    return sentenceCase(this.type)
  }
}
